import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth, useBrand } from '../../context/AuthContext';
import { useUI } from '../../context/UIContext';
import { Navbar, Nav, NavDropdown, Container, Form } from 'react-bootstrap';
import { ROUTES } from '../../constants/routes';
import { ThemeContext } from '../../context/ThemeContext';
import DevBrandSwitcher from '../../utils/DevBrandSwitcher';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, isUserManager, isMasterAdmin, logout } = useAuth();
  const { brand } = useBrand();
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { showSuccess } = useUI();
  const isDark = theme === 'dark';

  const isAuthPage = [ROUTES.LOGIN, ROUTES.MFA, ROUTES.ERROR].some(path =>
    location.pathname.includes(path)
  );

  const handleLogout = async () => {
    try {
      await logout();
      navigate(ROUTES.LOGIN);
      showSuccess('You have been logged out successfully.');
    } catch (error) {
      console.error('Logout error:', error);
      navigate(ROUTES.LOGIN);
    }
  };
  if (!brand) return null;

  return (
    <div className="mb-3">
      <div>
        <div className="d-flex justify-content-end">
            <Form.Check
              type="switch"
              id="theme-toggle"
              label={isDark? '☾': '☼'}
              title="Toggle light/dark mode"
              checked={isDark}
              onChange={toggleTheme}
            />
        </div>
      </div>
      <h1 className="text-center mb-3">
        <img
          src={brand.logoUrl}
          alt={`${brand.longName} logo`}
          style={{ maxHeight: '80px', maxWidth: '200px' }}
        />
      </h1>

      {!isAuthPage && user && (
        <Navbar expand="lg" className="shadow rounded mb-3 bg-secondary-soft">
          <Container fluid>
            <Nav.Item>
              <h1 className="text-muted mt-2">
                <strong>{brand.longName} </strong>
                <small>Energy Assistance Tool</small>
              </h1>
            </Nav.Item>

            <Navbar.Toggle aria-controls="navbarNav" />
            <Navbar.Collapse id="navbarNav">
              <Nav className="ms-auto align-items-center">
                <Nav.Link onClick={() => navigate(ROUTES.SEARCH)}>
                  Search
                </Nav.Link>

                {(isUserManager || isAdmin) && (
                  <NavDropdown title="Admin" align="end">
                    {isUserManager && (
                      <NavDropdown.Item onClick={() => navigate(ROUTES.ADMIN_USERS)}>
                        Manage Users
                      </NavDropdown.Item>
                    )}
                    {isAdmin && (
                      <>
                        <NavDropdown.Item onClick={() => navigate(ROUTES.ADMIN_BENEFIT_HISTORY)}>
                          Benefit History Report
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => navigate(ROUTES.ADMIN_AUDIT)}>
                          Audit Report
                        </NavDropdown.Item>
                      </>
                    )}
                    {isMasterAdmin && (
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item onClick={() => navigate(ROUTES.ADMIN_PAYMENT_FILE)}>
                          Payment & Rate Discount File Config
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={() => navigate(ROUTES.ADMIN_CALCULATOR)}>
                          Calculator Configuration
                        </NavDropdown.Item>
                      </>
                    )}
                  </NavDropdown>
                )}

                <Nav.Link onClick={handleLogout}>
                  Logout
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
    </div>
  );
};

export default Header;